export default {
  name: 'PlaceListItems',
  props: {
    items: {
      required: true,
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      required: true,
      type: Boolean,
      default: true
    }
  },
  methods: {
    /**
     * Pulsamos sobre el icono de menú
     *
     * @param {string} id - Id de item
     */
    handleClickMenuLink(id) {
      this.$emit('onClickMenu', id)
    }
  }
}
